<template>
    <hyper-modal :modal-class="modalClass" v-model="value" :class="modalSize">
        <h4 slot="header" class="modal-title" v-html="title"></h4>
        <template v-slot:body>
            <div v-html="message"></div>
        </template>
        <template v-slot:footer>
            <button @click="cancel()" type="button" class="btn btn-light" data-dismiss="modal">Close</button>
            <button
                @click="confirm()"
                type="button"
                class="btn"
                :class="[buttonClass]"
                data-dismiss="modal"
                v-text="confirmLabel || 'Confirm'"
            ></button>
        </template>
    </hyper-modal>
</template>

<script>
import HyperModal from "@/ui/HyperModal";

export default {
    components: {
        HyperModal
    },
    props: [
        "value",
        "type",
        "size",
        "cancelCallback",
        "confirmCallback",
        "title",
        "message",
        "confirmLabel"
    ],
    methods: {
        hideModal() {
            this.$emit("input", false);
        },
        cancel() {
            if (this.cancelCallback != null) {
                this.cancelCallback();
            }
            this.hideModal();
        },
        confirm() {
            if (this.confirmCallback != null) {
                this.confirmCallback();
            }
            this.hideModal();
        }
    },
    computed: {
        modalClass() {
            if (this.type == "danger") {
                return "danger";
            }
            return "primary";
        },
        buttonClass() {
            if (this.type == "danger") {
                return "btn-danger";
            }
            return "btn-primary";
        },
        modalSize() {
            return this.size ? this.size : "size-md";
        }
    }
};
</script>

<style>
</style>